<template>
    <b-dropdown
        id="botao-periodo"
        variant="primary"
        :text="texto"
    >
        <b-dropdown-item
            v-if="exibeHoje"
            @click="carregaHoje()"
        >
            Hoje
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeEstaSemana"
            @click="carregaEstaSemana()"
        >
            Esta semana
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeMesPassado"
            @click="carregaMesPassado()"
        >
            Mês passado
        </b-dropdown-item>
        <b-dropdown-item
            @click="carregaEsteMes()"
        >
            Este mês
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeUltimos30Dias" 
            @click="carregaUltimos30Dias()"
        >
            Últimos 30 dias
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeUltimos6Meses" 
            @click="carregaUltimos6Meses()"
        >
            Últimos 6 meses
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeUltimos12Meses" 
            @click="carregaUltimos12Meses()"
        >
            Últimos 12 meses
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeProximoMes"
            @click="carregaProximoMes()"
        >
            Próximo mês
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeTodoPeriodo"
            @click="carregaTodoPeriodo()"
        >
            Todo o período
        </b-dropdown-item>
        <b-dropdown-item
            v-if="exibeEscolhaPeriodo"
            @click="escolhaPeriodo()"
        >
            Escolha o período
        </b-dropdown-item>
    </b-dropdown>
</template>
<script>
import { listaMeses } from '@/shared/common/functions/data'
import { listaNomeMeses } from '@/shared/common/functions/data'
export default {
    props: {
        dataInicio: {
            default: null
        },
        dataFim: {
            default: null
        },
        chaveInicio: {
            default: 'data_inicio'
        },
        chaveFim: {
            default: 'data_fim'
        },
        atualizadoEm: {
            default: Date.now()
        },
        dataMes: {
            default: null
        },
        dataAno: {
            default: null
        },
        exibeHoje: {
            default: true
        },
        exibeEstaSemana: {
            default: true
        },
        exibeTodoPeriodo: {
            default: true
        },
        exibeEscolhaPeriodo: {
            default: true
        },
        exibeMesPassado: {
            default: true
        },
        exibeProximoMes: {
            default: true
        },
        exibeUltimos30Dias: {
            default: false
        },
        exibeUltimos6Meses: {
            default: false
        },
        exibeUltimos12Meses: {
            default: false
        }
    },
    data(){
        return {
            texto: '',
            lDataInicio: this.dataInicio,
            lDataFim: this.dataFim,
        }
    },
    mounted(){
        
        if(this.$route.query[this.chaveInicio]){
            this.lDataInicio = this.$route.query[this.chaveInicio];
        }

        if(this.$route.query[this.chaveFim]){
            this.lDataFim = this.$route.query[this.chaveFim];
        }
        this.formataTexto();
    },
    watch: {
        atualizadoEm(){
            this.lDataInicio = this.dataInicio
            this.lDataFim = this.dataFim
        }
    },
    methods: {
        pegaParametrosUrlAtual(){
            const searchParams = new URLSearchParams(location.search)
            const entradas = {}
            for(const entrada of searchParams.entries()){
                entradas[entrada[0]] = entrada[1]
            }
            return entradas
        },
        formataData(data = null){
            if(!data){
                return 'Indefinido'
            }
            if(data.length != 10){
                return ''
            }
            const moment = this.$moment(data, 'DD/MM/YYYY')
            if(!moment.isValid()){
                return ''
            }
            const retorno =  
            moment.format('DD')
            + '  '
            + listaMeses(moment.format('MM'))
            + '  '
            + moment.format('YYYY')
            return retorno
        },
        formataTexto(){
            if (this.dataMes && this.dataAno){
                this.texto = listaNomeMeses(this.dataMes) + ' de ' + this.dataAno;
            } else if (!this.lDataInicio && !this.lDataFim){
                this.texto = 'Todo o período';
            } else {

                const formato = 'DD/MM/YYYY'

                if (
                    this.lDataInicio && this.lDataFim 
                    && this.$moment(this.lDataInicio, formato).format('MM') == this.$moment(this.lDataFim, formato).format('MM')
                    && this.$moment(this.lDataInicio, formato).format('DD') == '01' 
                    && this.$moment(this.lDataFim, formato).format('DD') == this.$moment(this.lDataFim, formato).endOf('month').format('DD')
                    && this.$moment(this.lDataInicio, formato).format('YY') == this.$moment(this.lDataFim, formato).format('YY')
                ) {
                    
                    this.texto = listaNomeMeses(this.$moment(this.lDataInicio, formato).format('MM'))
                        + ' de ' + this.$moment(this.lDataInicio, formato).format('YYYY');

                } else {
                    this.texto = this.formataData(this.lDataInicio) + ' - ' + this.formataData(this.lDataFim);
                }   
            }
        },
        carregaPeriodo(periodo){
            
            this.lDataInicio = periodo[this.chaveInicio]
            this.lDataFim = periodo[this.chaveFim]

            this.formataTexto();

            this.$router.push(
                {
                    path: this.$route.path,  
                    query: Object.assign(
                        this.pegaParametrosUrlAtual(), periodo
                    )
                }
            ).catch(() => {})
            
            this.$emit('change', periodo)
        },
        carregaHoje(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().
                    format('DD/MM/YYYY')
            })
        },
        carregaEstaSemana(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    startOf('week').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().
                    add('7', 'days').
                    startOf('week').
                    format('DD/MM/YYYY')
            })
        },
        carregaMesPassado(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    subtract(1, 'month').
                    startOf('month').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().
                    subtract(1, 'month').
                    endOf('month').
                    format('DD/MM/YYYY')
            })
        },
        carregaUltimos30Dias(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    subtract(30, 'days').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().format('DD/MM/YYYY')
            })
        },
        carregaEsteMes(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    startOf('month').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().
                    endOf('month').
                    format('DD/MM/YYYY')
            })
        },
        carregaProximoMes(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    add(1, 'month').
                    startOf('month').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().
                    add(1, 'month').
                    endOf('month').
                    format('DD/MM/YYYY')
            })
        },
        carregaUltimos6Meses(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    subtract(6, 'month').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().format('DD/MM/YYYY')
            })
        },
        carregaUltimos12Meses(){
            this.carregaPeriodo({
                [this.chaveInicio]: 
                    this.$moment().
                    subtract(12, 'month').
                    format('DD/MM/YYYY'),
                [this.chaveFim]: 
                    this.$moment().format('DD/MM/YYYY')
            })
        },
        carregaTodoPeriodo(){
            this.carregaPeriodo({
                [this.chaveInicio]: "",
                [this.chaveFim]: ""
            })
        },
        escolhaPeriodo(){
            this.$parent.dSituacaoBuscaAvancada = true
        }
    },
}
</script>
